class BlogQuickFilters extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.quickFilters = this.querySelectorAll('.quick-filter-text input');
        Array.from(this.quickFilters).forEach((filter) => {
            if (window.location.href.includes(filter.value)) {
                filter.checked = true;
            }
            filter.addEventListener('click', (event) => {
                const baseUrl = `/blogs/${this.dataset.blogHandle}`;
                window.location.href = event.target.value === 'view-all' ? baseUrl : `${baseUrl}/tagged/${event.target.value}`;
            });
        })
    }

    filterPosts(type) {
        const event = new CustomEvent('filter-posts', { detail: { type } });
        this.dispatchEvent(event);
    }
}

customElements.define('blog-quick-filters', BlogQuickFilters);
